import React, { useState } from "react";
import { Link } from "react-router-dom";
import { 
  Check, Star, ChevronDown, ChevronUp, ArrowRight, Sparkles,
  Globe, Palette, TrendingUp, Monitor, FileText, Search, 
  Target, Mail, Layout, Building2, CreditCard, PenTool, 
  Video, Megaphone, BookOpen
} from "lucide-react";

const OffresPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  // Packs Stratégiques
  const packs = [
    {
      id: "visibilite",
      name: "Pack Visibilité 360",
      price: "2 500",
      icon: <Globe className="w-8 h-8" />,
      tagline: "Soyez trouvé, reconnu et suivi",
      description: "La solution clé en main pour développer votre présence digitale",
      features: [
        "Un site internet professionnel (pages stratégiques : Accueil, Services, À propos, Contact)",
        "Une optimisation SEO de base pour être trouvé sur Google",
        "La création et l'optimisation de vos 3 principaux réseaux sociaux (Instagram, Facebook, LinkedIn)",
        "Un mois de contenu planning pour démarrer votre communication"
      ],
      cta: "Je veux être visible",
      color: "blue",
      featured: true
    },
    {
      id: "image",
      name: "Pack Image Premium",
      price: "2 200",
      icon: <Palette className="w-8 h-8" />,
      tagline: "Créez une identité unique et mémorable",
      description: "Renforcez votre image de marque avec une identité visuelle cohérente",
      features: [
        "Création de logo & charte graphique complète (couleurs, typographies, univers visuel)",
        "Supports commerciaux essentiels (flyers, brochure ou catalogue)",
        "Templates personnalisés pour vos réseaux sociaux",
        "Papeterie professionnelle (cartes de visite, signature email, en-tête)"
      ],
      cta: "Je veux une identité unique",
      color: "purple",
      featured: false
    },
    {
      id: "croissance",
      name: "Pack Croissance +",
      price: "3 000",
      icon: <TrendingUp className="w-8 h-8" />,
      tagline: "Générez des leads et boostez vos ventes",
      description: "Accélérez votre croissance avec une stratégie d'acquisition performante",
      features: [
        "Audit et recommandations stratégiques personnalisés",
        "Mise en place d'un tunnel de conversion (de la découverte à l'achat)",
        "Campagne de test sur les réseaux sociaux (budget ads non inclus)",
        "Configuration d'une automation email pour suivre vos prospects"
      ],
      cta: "Je veux développer mon chiffre",
      color: "green",
      featured: false
    }
  ];

  // Services à la carte - 15 services complets (incluant événementiel)
  const servicesAlaCarte = [
    { icon: <Monitor className="w-5 h-5" />, name: "Création de site vitrine", desc: "Site de 3 à 5 pages, responsive et optimisé", price: "250" },
    { icon: <Palette className="w-5 h-5" />, name: "Création de logo", desc: "Logo unique + déclinaisons couleurs", price: "250" },
    { icon: <Globe className="w-5 h-5" />, name: "Stratégie réseaux sociaux (1 mois)", desc: "Calendrier éditorial + 8 publications prêtes", price: "250" },
    { icon: <Search className="w-5 h-5" />, name: "Audit SEO", desc: "Analyse technique + recommandations", price: "250" },
    { icon: <FileText className="w-5 h-5" />, name: "Création de flyers / brochures", desc: "Format A5 ou A4, recto/verso", price: "250" },
    { icon: <Target className="w-5 h-5" />, name: "Campagne d'ads (mise en place)", desc: "Configuration + stratégie d'enchères", price: "250" },
    { icon: <Layout className="w-5 h-5" />, name: "Tunnel de vente", desc: "Landing page + séquence d'emails", price: "250" },
    { icon: <CreditCard className="w-5 h-5" />, name: "Cartes de visite", desc: "Design premium recto/verso + fichiers HD", price: "150" },
    { icon: <PenTool className="w-5 h-5" />, name: "Charte graphique", desc: "Couleurs, typographies, règles d'usage", price: "350" },
    { icon: <Mail className="w-5 h-5" />, name: "Signature email professionnelle", desc: "Design HTML compatible tous clients mail", price: "100" },
    { icon: <Video className="w-5 h-5" />, name: "Vidéo promotionnelle courte", desc: "Montage 30-60 sec pour réseaux sociaux", price: "350" },
    { icon: <Megaphone className="w-5 h-5" />, name: "Community management (1 mois)", desc: "Animation et modération de vos réseaux", price: "400" },
    { icon: <BookOpen className="w-5 h-5" />, name: "Supports événementiels", desc: "Roll-ups, kakémonos, badges, totems", price: "300" },
    { icon: <Mail className="w-5 h-5" />, name: "Kit communication événement", desc: "Invitations, programmes, signalétique", price: "450" },
    { icon: <Globe className="w-5 h-5" />, name: "Couverture social media événement", desc: "Live posting + création contenu sur site", price: "350" },
  ];

  // Offre Grands Groupes
  const grandsGroupesFeatures = [
    "Définir votre positionnement et votre stratégie de marque",
    "Déployer votre identité sur l'ensemble de vos points de contact",
    "Piloter vos campagnes de croissance (ads, automation, contenu)",
    "Mesurer et optimiser vos performances avec des indicateurs dédiés"
  ];

  const faqs = [
    {
      question: "Comment choisir entre les 3 packs stratégiques ?",
      answer: "Chaque pack répond à un objectif précis : le Pack Visibilité 360 (2 500€) si vous devez développer votre présence digitale (site web, SEO, réseaux sociaux). Le Pack Image Premium (2 200€) si vous avez besoin d'une identité visuelle forte et cohérente. Le Pack Croissance+ (3 000€) si vous voulez générer des leads et automatiser votre acquisition. Nous pouvons vous aider à identifier le pack le plus adapté lors d'un appel diagnostic gratuit."
    },
    {
      question: "Que comprend exactement le Pack Visibilité 360 à 2 500€ ?",
      answer: "Ce pack inclut : un site internet professionnel avec les pages stratégiques (Accueil, Services, À propos, Contact), une optimisation SEO de base pour améliorer votre référencement Google, la création et l'optimisation de vos 3 réseaux sociaux principaux (Instagram, Facebook, LinkedIn), et un mois de contenu planning pour lancer votre communication. C'est la solution clé en main pour être visible en ligne."
    },
    {
      question: "Puis-je combiner plusieurs packs ou les personnaliser ?",
      answer: "Absolument ! Chaque pack peut être adapté à votre budget et vos objectifs. Vous pouvez également combiner des éléments de plusieurs packs ou compléter avec nos services à la carte (à partir de 250€). Demandez un devis personnalisé pour une offre sur mesure."
    },
    {
      question: "Le budget publicitaire est-il inclus dans le Pack Croissance+ ?",
      answer: "Non, le budget publicitaire (ads Facebook, Google, LinkedIn) n'est pas inclus dans le pack à 3 200€. Nous nous occupons de la stratégie, de la configuration et de l'optimisation de vos campagnes, mais vous gérez directement votre budget publicitaire auprès des plateformes. Nous vous recommandons un budget test minimum pour démarrer."
    },
    {
      question: "Quels sont les délais de réalisation pour chaque pack ?",
      answer: "Les délais varient selon le pack : Pack Image Premium environ 3-4 semaines, Pack Visibilité 360 environ 4-6 semaines (incluant le développement du site), Pack Croissance+ environ 3-4 semaines pour la mise en place initiale. Ces délais peuvent varier selon la complexité de votre projet et votre réactivité dans les validations."
    },
    {
      question: "Proposez-vous des facilités de paiement ?",
      answer: "Oui, nous proposons des paiements échelonnés pour tous nos packs : généralement en 2 à 3 fois selon le montant. Un acompte de 40% est demandé au démarrage, le solde étant réparti sur les étapes clés du projet. Contactez-nous pour discuter des modalités adaptées à votre situation."
    },
    {
      question: "Qu'est-ce que l'offre Accompagnement 360° Sur Mesure ?",
      answer: "C'est notre offre premium destinée aux grands groupes et entreprises à forte ambition. Nous prenons en charge l'intégralité de votre communication : stratégie de marque, déploiement sur tous les canaux, pilotage des campagnes (ads, automation, contenu) et suivi des performances avec des indicateurs dédiés. Le tarif est établi sur mesure selon vos besoins. Prenons rendez-vous pour en discuter."
    },
    {
      question: "Quelle est votre zone d'intervention ?",
      answer: "Avec 8 bureaux sur 3 continents (Lyon, Paris, Genève, Bruxelles, Nashville, Kigali, Bangui, Cotonou), nous intervenons partout dans le monde. Nous travaillons aussi bien en présentiel qu'à distance selon vos préférences et la nature du projet."
    }
  ];

  const getColorClasses = (color, type) => {
    const colors = {
      blue: {
        bg: "bg-blue-500",
        bgLight: "bg-blue-50",
        text: "text-blue-600",
        border: "border-blue-500",
        gradient: "from-blue-500 to-cyan-500"
      },
      purple: {
        bg: "bg-purple-500",
        bgLight: "bg-purple-50",
        text: "text-purple-600",
        border: "border-purple-500",
        gradient: "from-purple-500 to-pink-500"
      },
      green: {
        bg: "bg-emerald-500",
        bgLight: "bg-emerald-50",
        text: "text-emerald-600",
        border: "border-emerald-500",
        gradient: "from-emerald-500 to-teal-500"
      }
    };
    return colors[color][type];
  };

  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-br from-cyan-500 to-cyan-600" data-testid="offres-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-cyan-100 font-medium text-sm uppercase tracking-wider">Nos Offres</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
            Des solutions adaptées à chaque ambition
          </h1>
          <p className="text-white/80 text-lg max-w-2xl mx-auto">
            Packs stratégiques, services à la carte ou accompagnement sur mesure : trouvez l'offre qui correspond à vos besoins
          </p>
        </div>
      </section>

      {/* Packs Stratégiques */}
      <section className="py-20 bg-white" data-testid="packs-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-cyan-600 font-semibold text-sm uppercase tracking-wider">Offres Groupées</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-4">
              Les Packs Stratégiques
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Des solutions clé en main pour répondre à vos objectifs de visibilité, d'image ou de croissance
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {packs.map((pack) => (
              <div
                key={pack.id}
                className={`relative rounded-3xl p-8 transition-all duration-300 ${
                  pack.featured
                    ? 'bg-gradient-to-br ' + getColorClasses(pack.color, 'gradient') + ' text-white shadow-2xl scale-105 z-10'
                    : 'bg-white shadow-xl border border-gray-100 hover:shadow-2xl hover:-translate-y-1'
                }`}
                data-testid={`pack-${pack.id}`}
              >
                {pack.featured && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="inline-flex items-center gap-1 px-4 py-1.5 bg-white text-purple-600 text-sm font-bold rounded-full shadow-lg">
                      <Star className="w-4 h-4 fill-current" />
                      Populaire
                    </span>
                  </div>
                )}
                
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-6 ${
                  pack.featured ? 'bg-white/20 text-white' : getColorClasses(pack.color, 'bgLight') + ' ' + getColorClasses(pack.color, 'text')
                }`}>
                  {pack.icon}
                </div>

                <h3 className={`text-2xl font-bold mb-2 ${pack.featured ? 'text-white' : 'text-gray-900'}`}>
                  {pack.name}
                </h3>
                <p className={`text-sm mb-4 ${pack.featured ? 'text-white/80' : 'text-gray-500'}`}>
                  {pack.tagline}
                </p>
                
                <div className="mb-6">
                  <span className={`text-sm ${pack.featured ? 'text-white/70' : 'text-gray-500'}`}>À partir de</span>
                  <div className={`text-4xl font-bold ${pack.featured ? 'text-white' : 'text-gray-900'}`}>
                    {pack.price} <span className="text-xl">€</span>
                  </div>
                </div>

                <p className={`mb-6 text-sm ${pack.featured ? 'text-white/90' : 'text-gray-600'}`}>
                  {pack.description}
                </p>

                <ul className="space-y-3 mb-8">
                  {pack.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Check className={`w-5 h-5 flex-shrink-0 mt-0.5 ${pack.featured ? 'text-white' : getColorClasses(pack.color, 'text')}`} />
                      <span className={`text-sm ${pack.featured ? 'text-white/90' : 'text-gray-700'}`}>{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contact"
                  className={`block text-center py-4 px-6 rounded-full font-semibold transition-all duration-300 ${
                    pack.featured
                      ? 'bg-white text-purple-600 hover:bg-gray-100 shadow-lg'
                      : getColorClasses(pack.color, 'bg') + ' text-white hover:opacity-90'
                  }`}
                  data-testid={`cta-${pack.id}`}
                >
                  {pack.cta}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services à la carte */}
      <section className="py-20 bg-gray-50" data-testid="services-carte-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-cyan-600 font-semibold text-sm uppercase tracking-wider">Flexibilité</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-4">
              Services à la Carte
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Vous avez un besoin spécifique ? Chaque service peut être adapté à votre budget et vos objectifs.
            </p>
            <div className="inline-block mt-4 px-6 py-2 bg-cyan-100 text-cyan-700 rounded-full font-semibold">
              À partir de 250 € par service
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {servicesAlaCarte.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-cyan-200"
                data-testid={`service-carte-${index}`}
              >
                <div className="w-10 h-10 rounded-lg bg-cyan-100 flex items-center justify-center text-cyan-600 mb-4">
                  {service.icon}
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{service.name}</h3>
                <p className="text-gray-500 text-sm mb-3">{service.desc}</p>
                <p className="text-cyan-600 font-bold">À partir de {service.price} €</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-white font-semibold rounded-full hover:bg-cyan-400 transition-all duration-300 shadow-lg"
              data-testid="cta-devis-personnalise"
            >
              Demander un devis personnalisé
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Offre Grands Groupes */}
      <section className="py-20 bg-gray-900" data-testid="grands-groupes-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <Sparkles className="w-5 h-5 text-cyan-400" />
                <span className="text-cyan-400 font-semibold text-sm uppercase tracking-wider">Offre Premium</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Accompagnement 360° Sur Mesure
              </h2>
              <p className="text-gray-300 text-lg mb-6">
                Pour les entreprises à forte ambition, nous prenons en main votre communication dans son intégralité. 
                De la stratégie de marque à l'exécution des campagnes, nous devenons votre partenaire privilégié.
              </p>
              <p className="text-gray-400 mb-8">
                Une stratégie de marque globale et déployée sur tous les canaux, avec des indicateurs de performance dédiés pour mesurer et optimiser vos résultats.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-white font-semibold rounded-full hover:bg-cyan-400 transition-all duration-300"
                data-testid="cta-grands-groupes"
              >
                Prenons rendez-vous
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="flex items-center gap-3 mb-6">
                <Building2 className="w-8 h-8 text-cyan-400" />
                <span className="text-white font-semibold text-lg">Ce que nous prenons en charge</span>
              </div>
              <ul className="space-y-4">
                {grandsGroupesFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                    <span className="text-white/90">{feature}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-6 border-t border-white/20">
                <p className="text-sm text-gray-400">
                  <strong className="text-white">Idéal pour :</strong> Grands comptes, entreprises en forte croissance, organisations multi-sites
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white" data-testid="faq-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-cyan-600 font-semibold text-sm uppercase tracking-wider">FAQ</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4">
              Questions fréquentes
            </h2>
            <p className="text-gray-600 mt-4">
              Vous avez des questions sur nos offres ? Nous avons les réponses
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-xl overflow-hidden"
                data-testid={`faq-${index}`}
              >
                <button
                  className="w-full px-6 py-5 flex justify-between items-center text-left bg-white hover:bg-gray-50 transition-colors"
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                >
                  <span className="font-semibold text-gray-900">{faq.question}</span>
                  {openFaq === index ? (
                    <ChevronUp className="w-5 h-5 text-cyan-500" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-400" />
                  )}
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center p-8 bg-gray-50 rounded-2xl">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Vous ne trouvez pas la réponse à votre question ?
            </h3>
            <p className="text-gray-600 mb-4">
              Notre équipe est là pour vous aider. Contactez-nous directement.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-cyan-600 font-semibold hover:underline"
            >
              Nous contacter <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-gradient-to-br from-cyan-500 to-cyan-600" data-testid="offres-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Prêt à transformer votre marque ?
          </h2>
          <p className="text-white/80 text-lg mb-10">
            Discutons de vos objectifs et trouvons ensemble la solution idéale
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-cyan-600 font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 shadow-lg"
              data-testid="offres-cta-contact"
            >
              Demander un devis gratuit
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white/30 text-white font-semibold rounded-full hover:bg-white/10 hover:border-white/50 transition-all duration-300"
              data-testid="offres-cta-services"
            >
              Découvrir nos services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OffresPage;
